import { createSelector } from 'reselect';

import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';
import { getLatestSetupActivity } from 'lib/selectors/getLatestSetupActivity';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getIsPaused } from './getIsPaused';
import {
  getLatestSetupTicketClockOut,
  getSetupLaborTicketsForOperation,
} from './getSetupLaborTicketsForOperation';

/**
 * Setup segment end for elapsed duration tickers. Null while setup is actively running.
 */
const getLatestSetupActivityEndAt = createSelector(
  [
    getPostLaborUpdatesOnNats,
    getLatestSetupActivity,
    getIsPaused,
    getCurrentLaborTicket,
    getSetupLaborTicketsForOperation,
  ],
  (
    natsFlowEnabled,
    { end: latestSetupActivityEndAt },
    isPaused,
    currentLaborTicket,
    setupTickets
  ) => {
    if (natsFlowEnabled) {
      const isActiveOpenSetup =
        currentLaborTicket?.type?.toLowerCase() === 'setup' &&
        currentLaborTicket?.state === 'OPEN' &&
        !isPaused;

      if (isActiveOpenSetup) {
        return null;
      }

      if (isPaused && currentLaborTicket?.clockOut) {
        return currentLaborTicket.clockOut;
      }

      return getLatestSetupTicketClockOut(setupTickets);
    }

    return latestSetupActivityEndAt || null;
  }
);

export { getLatestSetupActivityEndAt };
